import { AjaxState } from "./state";
export const initial: AjaxState = {
  loading: false,
  pending: [],
  total: [],
  ping: 0
};
export default initial;
